// extracted by mini-css-extract-plugin
module.exports = {"bigCalendar":"Calendar_bigCalendar__39oOO"};